import React from 'react';
import { components } from 'react-select';
import { customStyles } from '../../components/AccountManagement/CustomStyles';

export const TeamMultiSelectOption = (props) => (
  <components.Option {...props}>
    <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: '8px' }}
      />
      <span style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>{props.label}</span>
    </div>
  </components.Option>
);

export const TeamMultiSelectMultiValue = ({ children, ...props }) => (
  <components.MultiValue {...props}>{children}</components.MultiValue>
);

export const TeamMultiSelectValueContainer = ({ children, ...props }) => {
  const { getValue, hasValue } = props;
  const selectedCount = getValue().length;
  return (
    <components.ValueContainer {...props}>
      {hasValue ? `${selectedCount} Teams Selected` : children}
    </components.ValueContainer>
  );
};

export const getTeamMultiSelectStyles = (showGroupsError) => ({
  ...customStyles.popup,
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#e6f3ff' : 'white',
    color: 'black',
    padding: '8px',
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e6f3ff',
    maxWidth: 'calc(100% - 20px)',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'black',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '150px',
  }),
  menu: (provided) => ({
    ...provided,
    width: 'auto',
    minWidth: '100%',
    maxWidth: '500px',
    zIndex: 9999,
    backgroundColor: '#fff',
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '300px',
  }),
  container: (provided) => ({
    ...provided,
    width: '300px',
  }),
  control: (provided, state) => ({
    ...provided,
    height: '44px',
    paddingRight: '30px',
    alignItems: 'center',
    gap: '10px',
    flexShrink: 0,
    borderRadius: '6px',
    borderWidth: '0.5px',
    borderColor: showGroupsError ? '#DC3545' : '#686869',
    '&:hover': {
      borderColor: showGroupsError ? '#DC3545' : '#686869',
    },
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '16px',
    fontFamily: '"Roboto" !important',
    fontWeight: 400,
    lineHeight: '24px !important',
    width: '300px',
    backgroundColor: '#FFFFFF',
    color: '#000',
    padding: '15px 12px 10px 12px',
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    padding: '0',
    display: 'flex',
    alignItems: 'flex-end',
    paddingBottom: '4px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    right: '0',
    top: '0',
    paddingRight: '8px',
    zIndex: 1,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: 0,
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    height: '70%',
    alignSelf: 'center',
    marginRight: '8px',
  }),
});
